import { ImageContentGridBottom } from "../../../../modules/content/components/ImageContentGridBottom/ImageContentGridBottom";
import { ImageContentGridTop } from "../../../../modules/content/components/ImageContentGridTop/ImageContentGridTop";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IImageContentGridBlockProps } from "./ImageContentGridBlock.props";

export const ImageContentGridBlock = (props: IImageContentGridBlockProps) => {
  const {
    alignment,
    anchorId,
    buttons,
    description,
    eyebrow,
    heading,
    headingEffect,
    items,
    parentClass,
    spacing,
    variant,
  } = props;
  if (!items?.length) return null;
  return (
    <DaylightSection
      className={`border-y border-border bg-surface-100 ${parentClass || ""}`}
      id={anchorId}
      spacing={spacing}
    >
      <div className="flex flex-col gap-10 md:gap-14">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingEffect={headingEffect}
          reveal
        />
        {variant === "image-bottom" ? (
          <ImageContentGridBottom {...props} headingAs={heading ? "h3" : "h2"} />
        ) : (
          <ImageContentGridTop {...props} headingAs={heading ? "h3" : "h2"} />
        )}
      </div>
    </DaylightSection>
  );
};

ImageContentGridBlock.displayName = "Block::ImageContentGridBlock";
